import React from "react";

import { api } from "../../api/api";
import { AutoForm } from "../../core/form/AutoForm";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { Modal } from "../../core/ui/Modal";
import { Icon } from "../../core/ui/icons";
import { Text } from "../../core/form/Text";
import { useDebounce } from "../../core/hooks/useDebounce";
import { validateEmail } from "../../core/utils/validate";
import { IconMessage } from "../../core/ui/IconMessage";
import { useConditional } from "../../core/hooks/useConditional";

type States = "starting" | "checking-email" | "email-available" | "email-not-available";

export function RegisterModal(props: {
	initialValues?: any,
    onClose: () => void,
}) {

	const [, refresh] = React.useState({});

	const context = useDataContext({
		initialValue: {

			state: "starting" as States,

			email: "",
			password: "",
			passwordConfirm: "",
			name: {
				given1: "",
				family: "",
			},

			...props.initialValues

		},
	});

	context.customValidate = (v) => {
		if (!validateEmail(context.value.email)) {
			v.errors.push({ message: "Must be a valid email address", prop: "email" });
			return;
		}

		if (context.value.state !== "email-available") v.errors.push({ message: "Email address is not available" });
	}

	const [email, setEmail] = useDebounce<string>(750, context.value.email);
	React.useEffect(() => {

		if (!validateEmail(email)) {
			context.setValue("state", "starting");
			refresh({});
			return;
		}

		context.setValue("state", "checking-email");
		api.register_check({ email, }).then((resp: any) => {
			if (resp.available) {
				context.setValue("state", "email-available");
				context.setValue("email", email, true);
				refresh({});
			} else {
				context.setValue("state", "email-not-available");
				refresh({});
			}
		}).catch((e) => {
			context.setValue("state", "email-not-available");
			refresh({});
		});

	}, [context, email]);

	const successModal = useConditional(() => {
		return (
			<Modal
				title="Success"

				showCancel={false}
				cancelTitle="Close"

				showSave={false}
				
				style={{width: "50vw"}}
				onSave={props.onClose}
			>
				<div className="flex vert">
					<Icon type="email_send_color" />

					<p>You have been sent an email to confirm, please click the link in it to continue.</p>
				</div>


			</Modal>
		);
	});


	return (
		<DataContext.Provider value={context}>

			<Modal
				title="Create your account"
				style={{width: "650px"}}
				onCancel={props.onClose}
				onSave={() => {
					const v = context.value;

					api.register_create({
						email: v.email,
						name: v.name,
						password: v.password,
					}, context).then((res: any) => {
						successModal.show({});
						
					}).catch((err: any) => {

					});
				}}
				saveTitle="Register"
			>

				<div className="flex horiz">

					<div
						className="flex vert align-stretch fill modal-content-padded"
					>

						{/* {(state !== "email-available") &&  */}
						<Text
							prop="email"
							//title="Email"
							placeholder="Email address"
							className="font-large fill"

							// style={{width:"100%"}}
							
							onChange={(e, value) => {
								setEmail(value);
							}}
						/>
						{/* }  */}
						{/* {(state === "email-available") && 
							<b className="font-large">{context.value.email}</b>
						} */}

						{(context.value.state === "checking-email") && 
							<IconMessage type="spinner" className="margin-top-2" message="Checking availability" />
						}

						{(context.value.state === "email-not-available") && 
							<IconMessage type="cross" color="white" className="bg-error text-inverse margin-top-2" message="Email is already being used" />
						}

						{(context.value.state === "email-available") && 
							<IconMessage type="tick" color="white" className="bg-success text-inverse margin-top-2" message="Email available" />
						}

						<div className="flex vert align-start fill width-100pc margin-top-5">
							<AutoForm
								fields={[
									{ prop: "name.given1", title: "First name", options: {required: true} },
									{ prop: "name.family", title: "Last name", options: {required: true} },
									{ prop: "password", title: "Password", options: {required: true} },
									{ prop: "passwordConfirm", title: "Confirm password", options: {required: true} },
								]}
								// layout={(get) => {
								// 	return (
								// 		<div className="">
								// 			{get("name.given1")}
								// 		</div>
								// 	)
								// }}
							/>
						</div>

					</div>

				</div>

				{successModal.render()}

			</Modal>

		</DataContext.Provider>
	)
}
